import { darken } from 'polished'
import styled, { css } from 'styled-components'
import fadeIn from '../../styles/animations/fadeIn'
import ripple from '../../styles/animations/ripple'

interface FieldProps {
  readonly error: boolean
  background?: string
  small?: boolean
  gray?: boolean
}

export const Container = styled.div`
  ${fadeIn};
  height: 100%;
`

export const Field = styled.input<FieldProps>`
  -webkit-appearance: none;
  font-size: 14px;
  color: ${({ theme }) => theme.colors.input};
  height: ${({ small }) => (small ? '35px' : '45px')};
  font-weight: 600;
  transition: border-color 200ms linear;
  background: ${({ background }) => (background ? background : 'transparent')};

  border: none;
  &::placeholder {
    font-size: 14px;
    font-weight: 500;
    color: ${({ theme }) => darken(-0.6, theme.colors.placeholder)};
  }

  width: 100%;

  ${({ error }) =>
    error &&
    css`
      border-color: ${({ theme }) => theme.colors.error};

      &:hover {
        border-color: ${({ theme }) => darken(0.2, theme.colors.error)};
      }
    `};

  ${({ gray }) =>
    gray &&
    css`
      background-color: ${({ theme }) => theme.colors.secondary};
      padding: 0px 10px;
      border-radius: 10px;
    `}
`

export const Content = styled.div<any>`
  position: relative;
  border-radius: 10px;
  gap: 15px;
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  padding: 0px 10px;
  :hover,
  :focus {
    border-color: ${({ theme }) => darken(0.4, theme.colors.border)};
  }
  img {
    margin: auto;
    width: 20px;
    height: 20px;
  }
  background: ${({ theme }) => darken(-0.6, theme.colors.primary)};
  color: ${({ theme }) => theme.colors.input};
`
export const ImageEdit = styled.div`
  ${ripple}
  cursor: pointer;
  position: absolute !important;
  bottom: -10px;
  right: -10px;
`

export const Label = styled.label<any>`
  display: inline-block;
  font-size: 14px;
  font-weight: 500;
  margin-bottom: 5px;
  color: ${({ theme }) => theme.colors.primary};
`

export const Error = styled.span`
  color: ${({ theme }) => theme.colors.error};
  font-size: 12px;
`
